import { render } from "./NotFoundPage.vue?vue&type=template&id=890e5d92&scoped=true"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=890e5d92&scoped=true&lang=scss"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890e5d92"]])

export default __exports__